<form class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/shade']">Shade</a> > {{ shade.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button type="submit" mat-flat-button color="primary" (click)="save()">
        <mat-icon>save</mat-icon> Save
      </button>
      <button type="button" mat-stroked-button>Reset</button>
    </div>
  </div>
  <div class="form-card">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Name</mat-label>
          <input type="text" matInput name="name" [(ngModel)]="shade.name">
        </mat-form-field>
      </div>
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Code</mat-label>
          <input type="text" matInput name="code" [(ngModel)]="shade.code">
        </mat-form-field>
      </div>
    </div>
  </div>
  <app-audit-log-viewer model="shade" [recordId]="shade.id"></app-audit-log-viewer>
</form>
